import { supabase } from "./supabase.js";

const STORAGE_KEY = "solitaire-journey-set";

// ============================================================
// loadJourneySet — gibt das aktuelle Journey-Set zurück
// ============================================================

export async function loadJourneySet(userId: string | null): Promise<number> {
  if (!userId) {
    return loadFromStorage();
  }

  const { data, error } = await supabase
    .from("profiles")
    .select("journey_current_set")
    .eq("id", userId)
    .single();

  if (error || !data) {
    console.error("[journey] load failed:", error?.message);
    return loadFromStorage();
  }

  return (data.journey_current_set as number | null) ?? 1;
}

// ============================================================
// saveJourneySet — speichert den Fortschritt
// ============================================================

export async function saveJourneySet(userId: string | null, setNumber: number): Promise<void> {
  // Nie rückwärts speichern — Fortschritt nur vorwärts
  const currentLocal = loadFromStorage();
  if (setNumber > currentLocal) {
    saveToStorage(setNumber);
  }

  if (!userId) return;

  // DB: nur updaten wenn neuer Wert höher ist als gespeicherter
  const { error } = await supabase
    .from("profiles")
    .update({ journey_current_set: setNumber })
    .eq("id", userId)
    .or(`journey_current_set.is.null,journey_current_set.lt.${setNumber}`);

  if (error) {
    console.error("[journey] save failed:", error.message);
  }
}

// ============================================================
// syncJourneyOnLogin — gleicht localStorage mit DB ab
// ============================================================

export async function syncJourneyOnLogin(userId: string): Promise<void> {
  const local = loadFromStorage();
  if (local <= 1) return; // nichts zu syncen

  const dbSet = await loadJourneySet(userId);
  const max = Math.max(local, dbSet);

  if (max > dbSet) {
    await saveJourneySet(userId, max);
  }

  try { localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
}

// ============================================================
// Helpers
// ============================================================

function loadFromStorage(): number {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v) {
      const n = parseInt(v, 10);
      if (!isNaN(n) && n >= 1) return n;
    }
  } catch { /* ignore */ }
  return 1;
}

function saveToStorage(setNumber: number): void {
  try { localStorage.setItem(STORAGE_KEY, String(setNumber)); } catch { /* ignore */ }
}
